import { createSlice } from '@reduxjs/toolkit';
import { createSelectorFn } from './common';

const initialState = {
  isShow: false,
  messageKey: '',
  isError: false,
  errorCode: null,
  isMobile: false
};

const naverWorksPopupDataSlice = createSlice({
  name: 'naverWorksPopup',
  initialState,
  reducers: {
    showNaverWorksPopup: (state, action) => {
      const { messageKey, isError, errorCode, isMobile } = action.payload;
      state.isShow = true;
      state.messageKey = messageKey;
      state.isError = isError;
      state.errorCode = isError ? errorCode : null;
      state.isMobile = isMobile;
    },
    hideNaverWorksPopup: () => initialState
  }
});

export const { showNaverWorksPopup, hideNaverWorksPopup } = naverWorksPopupDataSlice.actions;
export const useNaverWorksPopupDataSliceSelector = createSelectorFn(naverWorksPopupDataSlice);
export default naverWorksPopupDataSlice;
